<template>
    <b-loading
      :is-full-page="true"
      :active.sync="loading"
      :can-cancel="true"
      v-if="loading"/>
    <div v-else>
        <section>
          <div class="columns is-centered">
            <div class="column is-one-third">
              <div class="company-logo">
                <!-- <img v-if="logo" :src="logo" class="logo" /> -->
                <!-- <img src="@/assets/pd_logo_light.png" class="logo" alt=""> -->
                <img v-if="crow !== true" src="@/assets/pd_logo_light.png" class="logo" />
                <img v-else src="@/assets/CROW-hoofdlogo.png" class="logo"/>
              </div>
            </div>
          </div>
        </section>

        <section class="form-title" :style="{backgroundColor: primary}">
          <div class="container form-title-container">
            <div class="columns is-centered">
              <div class="column is-full">
                <h1 class="is-size-3 has-text-weight-bold"><span v-if="crow === true">Past Performance: </span>{{ surveyTitle }}</h1>
                <!-- Omgevingsenquête Herinrichting Markt Boxtel -->
              </div>
            </div>
          </div>
        </section>
        <section class="intro-section has-background-white-ter" :style="{backgroundImage: 'linear-gradient(' + primary + ', white 80%)'}">
          <div class="container intro">
            <div class="columns">
                <div class="column is-two-fifths intro-stats">
                  <div class="stat">
                    <p class="stat-title">Project</p>
                    <h2 class="is-size-5 has-text-weight-bold">{{projectName}}</h2>
                  </div>
                  <!-- <div class="stat" v-if="this.$store.getters.getInfo.crow !== true">
                    <p class="stat-title">Contactpersoon</p>
                    <h2 class="is-size-5 has-text-weight-bold">{{this.$store.getters.getInfo.contactperson}}</h2>
                  </div>
                  <div class="stat" v-if="this.$store.getters.getInfo.crow !== true">
                    <p class="stat-title">Vragen?</p>
                    <h2 class="is-size-5 has-text-weight-bold">{{this.$store.getters.getInfo.email}}</h2>
                  </div> -->
                  <div class="stat" v-if="crow">
                    <p class="stat-title">Aannemer</p>
                    <h2 class="is-size-5 has-text-weight-bold">{{contractorName}}</h2>
                  </div>
                  <div class="stat" v-if="crow === true">
                    <p class="stat-title">Adres aannemer</p>
                    <h2 class="is-size-5 has-text-weight-bold">
                      {{addres}},
                      {{city}}
                    </h2>
                  </div>
                </div>

              <div class="column">
                <div class="column intro-text has-text-grey-darker">
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="container title-area">
            <div class="columns is-centered">
              <div class="column is-full intro-message">
                <h3 class="is-size-5 has-text-weight-medium has-text-black-ter start-title">{{message}}</h3>
              </div>
            </div>
          </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'

const endpoint = '/survey/validate'

export default {
  name: 'Navbar',
  data () {
    return {
      crow: false,
      surveyTitle: '',
      projectName: '',
      contractorName: '',
      addres: '',
      city: '',
      message: '',
      primary: '#ffffff',
      logo: null,
      loading: true
    }
  },
  created () {
      let v = this;

      this.$http
          .post(process.env.EMET_API_URL + endpoint, {surveyId: this.$route.params.id, token: this.$route.params.token}, {emulateJSON: true})
          .then((response) => {
            if (response.data.form.survey_info) v.projectName = response.data.form.survey_info.project_name;
            v.surveyTitle = response.data.form.name;
            v.crow = response.data.form.crow;
            if (v.crow === true) {
              v.contractorName = response.data.form.crowMeta.contractor.CROW_contractorInfo.ContractorName
              v.addres = response.data.form.crowMeta.contractor.CROW_contractorInfo.Address;
              v.city = response.data.form.crowMeta.contractor.CROW_contractorInfo.City;
            }
            v.primary = response.data.form.survey_settings.primary_color;
            v.message = response.data.msg
            v.logo = response.data.form.survey_settings.logo;
            v.loading = false;
          }, 
          (error) => {
            alert('error')
          })
  }
}
</script>

<style scoped>

.form-title {
  /* border-top-left-radius: 10px;
  border-top-right-radius: 10px; */
  padding-top: 38px;
  padding-bottom: 38px;
  /* background-color: #feb900; */
  /* background-color: #e63126; */
  text-align: center;
  color: white;
  font-size: 16px;
}

.form-title-container {
  padding-left: 20px;
  padding-right: 20px;
}

.intro-section {
  padding-left: 20px;
  padding-right: 20px;
}

.intro {
  padding-top: 60px;
  padding-bottom: 60px;
  padding-left: 40px;
  padding-right: 40px;
  max-width: 980px;

  background-color: white;
  border-radius: 10px;
  box-shadow: 0 1px 30px rgba(0,0,0,0.08);
}

.intro-text {
  padding-left: 18px;
  white-space: pre-wrap;
  /* text-align: left; */
  /* font-size: 14px;
  font-weight: 500; */
}

.intro-stats {
  padding-top: 10px;
  padding-right: 18px;
  text-align: right;
}

.stat {
  margin-top: 10px;
}

.stat-title {
  margin-bottom: -3px;
}

.title-area {
  margin-top: 42px;
  margin-bottom: 60px;
  text-align: center;
}

.start-title {
  padding-bottom: 42px;
  /* color: #111f39; */
}

.company-logo {
  margin-top: 35px;
  margin-bottom: 30px;
  text-align: center;
}

.logo {
  height: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/Validate.vue